import { createReducer, on } from '@ngrx/store';

import { clearReturnRoute, setPreviousRoute, setReturnRoute } from '@main-application/store/actions/route-state.action';

export const routeStateFeatureKey = 'routeState';

export interface RouteState {
  previousRoute?: string;
  returnRoute?: string;
}

export const initialState: RouteState = {
  previousRoute: undefined,
  returnRoute: null,
};

export const reducer = createReducer(
  initialState,
  /**
   * set previous route
   */
  on(setPreviousRoute, (state, action) => ({
    ...state,
    previousRoute: action.previousRoute,
  })),
  on(setReturnRoute, (state, action) => ({
    ...state,
    returnRoute: action.returnRoute,
  })),
  on(clearReturnRoute, (state, action) => ({
    ...state,
    returnRoute: null,
  }))
);
